import { combineEpics } from 'redux-observable'

import notificationsEpics from './Notifications/epics'
import reportingReasonsEpics from './ReportingReasons/epics'

export default combineEpics(notificationsEpics, reportingReasonsEpics)
